import { tokens } from '@cellula/react-theme-patient';
import { ReactNode } from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	background: ${tokens.color.bg.surface};
	flex-grow: 1;
	color: ${tokens.color.content.default};

	${tokens.breakpointQuery.small} {
		position: relative;
		max-width: calc(600px - ${tokens.spacing.x4});
		margin: ${tokens.spacing.x6} auto;
		border: 1px solid ${tokens.color.border.default};
		border-radius: ${tokens.borderRadius.large};
		overflow: hidden;
		min-height: 100%;
		flex-grow: 0;
	}

	/* TODO: Remove when old patient web i gone 🧹🧼🚿🧽🚽 */
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		color: ${tokens.color.content.default};
		margin: 0;
	}
`;

interface PatientFlowContainerProps {
	children: ReactNode;
}

export function PatientFlowContainer({ children }: PatientFlowContainerProps) {
	return <StyledContainer>{children}</StyledContainer>;
}
